import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { typography, colors } from '@resiliatech/birdsong'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0;

  &:hover {
    // Target the child component when hovering over the parent

    .goal-comment-actions {
      visibility: visible;
    }
  }
`

export const TopHalf = styled.div`
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
`

export const Details = styled.div`
  display: grid;
  grid-template-columns: 35px auto;
  grid-template-rows: auto auto;
  padding-bottom: 12px;
`

export const UserName = styled.div`
  ${typography.down2.regularSans}
  grid-area: 1 / 2;
`

export const AssociatedTask = styled.div`
  ${typography.down2.regularSans}
  line-height:250%;
  letter-spacing: 1px;
  text-transform: uppercase;
  grid-area: 1/2;
  color: ${colors.text.secondary};
`

export const Avatar = styled.div`
  align-items: center;
  display: flex;
  grid-row: span 2;
`

export const Actions = styled.div`
  display: flex;
  gap: 4px;
  visibility: hidden;
`

export const Description = styled(Typography)`
  ${typography.baseline.regularSans}
  padding-left: 6px;
`
